import { render, staticRenderFns } from "./DadosAtendimento.vue?vue&type=template&id=7eb73348"
import script from "./DadosAtendimento.vue?vue&type=script&lang=ts"
export * from "./DadosAtendimento.vue?vue&type=script&lang=ts"
import style0 from "./DadosAtendimento.vue?vue&type=style&index=0&id=7eb73348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports